import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { mutationEditorQuestionImportPreview } from 'gql/mutations/editor';
import { useQueryLocalEditor } from 'gql/queries/local';
import { getQuestionRecto, getQuestionVerso } from 'questions';

import QuestionPreview from './QuestionPreview';

const QuestionPreviewContainer = ({ course, ...props }) => {
  const { t } = useTranslation();
  const {
    data: {
      editor: { questionEditing },
    },
  } = useQueryLocalEditor();
  const [seeRecto, setSeeRecto] = useState(true);
  const handleToggleCard = useCallback(() => setSeeRecto((p) => !p), []);
  useEffect(() => setSeeRecto(true), [questionEditing]);
  const rectoComponent = getQuestionRecto(questionEditing?.type);
  const versoComponent = getQuestionVerso(questionEditing?.type);
  const initialValues = useMemo(
    () => ({
      answer: rectoComponent?.defaultAnswer(questionEditing),
    }),
    [questionEditing, rectoComponent],
  );
  const questionWithSolution = useMemo(
    () => ({
      ...questionEditing,
      solution: versoComponent?.defaultSolution(questionEditing),
    }),
    [questionEditing, versoComponent],
  );
  return (
    <QuestionPreview
      course={course}
      handleBack={mutationEditorQuestionImportPreview}
      handleToggleCard={handleToggleCard}
      initialValues={initialValues}
      question={questionWithSolution}
      rectoComponent={rectoComponent}
      seeRecto={seeRecto}
      t={t}
      versoComponent={versoComponent}
      {...props}
    />
  );
};

QuestionPreviewContainer.propTypes = {
  course: PropTypes.object.isRequired,
};

export default QuestionPreviewContainer;
